<template>
        <ViewComponent>
                <template #title>{{ data.title }}</template>
                <template #content>
                        <div v-html="data.content"></div>
                </template>
        </ViewComponent>
</template>
<script setup>
import ViewComponent from "../components/View.vue"
const { t } = useI18n();

const { data } = defineProps({
        data: Object
})

</script>
